export enum PaymentMethodType {
  Balance = 'balance',
  Cash = 'cash',
  Custom = 'custom',
  Imports = 'imports',
}
